const LoadingPlayerCard = () => {
  return (
    <div
      className="h-35 touch-device:h-33.75 w-full rounded-md bg-[linear-gradient(163deg,_#2F2F2F_0%,_#232323_100%)] animate-pulse"
      style={{
        boxShadow:
          "inset 0px -1px 1px rgba(0, 0, 0, 0.5), inset 0px 1px 1px rgba(255, 255, 255, 0.25)",
      }}
    ></div>
  );
};

const LoadingPlayersList = () => {
  return (
    <div className="flex flex-col gap-y-2">
      {Array.from({ length: 20 }).map((_, index) => (
        <LoadingPlayerCard key={index} />
      ))}
    </div>
  );
};

export default LoadingPlayersList;
